import { render } from "./Instruments.vue?vue&type=template&id=bf0c2bdc&scoped=true"
import script from "./Instruments.vue?vue&type=script&lang=js"
export * from "./Instruments.vue?vue&type=script&lang=js"

import "./Instruments.vue?vue&type=style&index=0&id=bf0c2bdc&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf0c2bdc"]])

export default __exports__